import { ManagementUser } from "../core/models/management-user.model";

/**
 * Whether or not the current user should be able to view the school filter for a report
 */
export function canViewSchoolFilter(currentUser: ManagementUser | null): boolean {
  if (!currentUser) {
    return false;
  }

  return currentUser.isSchoolUser() || currentUser.isSchoolAdmin() || currentUser.isFILUser() || currentUser.isDistrictUser();
}

/**
 * Whether or not the current user should be able to view the co-teacher filter for a report
 */
export function canViewCoTeacherFilter(currentUser: ManagementUser | null): boolean {
  if (!currentUser) {
    return false;
  }

  return currentUser.isTeacherUser();
}

export function canLookupTeacherListForSchool(currentUser: ManagementUser | null): boolean {
  if (!currentUser) {
    return false;
  }

  return currentUser.isFILUser()
    || currentUser.isDistrictUser()
    || currentUser.isSchoolUser()
    || currentUser.isTeacherUser()
    || currentUser.isSchoolAdmin()
    || currentUser.isCustomerServiceUser();
}

export function canLookupSchoolListForDistrict(currentUser: ManagementUser | null): boolean {
  if (!currentUser) {
    return false;
  }

  return currentUser.isFILUser() || currentUser.isDistrictUser() || currentUser.isCustomerServiceUser();
}

export function canChangeSchool(currentUser: ManagementUser | null): boolean {
  if (!currentUser) {
    return false;
  }

  return currentUser.isFILUser() || currentUser.isDistrictUser() || currentUser.isCustomerServiceUser();
}

export function simpleFormatDate(year: number, month: number, day: number) {
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
